/* eslint-disable no-unused-vars */
import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { FormProvider, useForm } from 'react-hook-form'
import { Popconfirm } from 'antd'
import { ModalWrapper } from './styled'
import { PrimaryButton, OutlineButton, OutlineDeleteButton } from '../../../../components/button'
import { DueDateTime } from '../form-due-date-time'
import { Status } from '../form-status'
import { TASK_CATEGORY_VALUE, STATUS_VALUE, DEFAULT_PAGE } from '../../constants'
import useQuery from '../../../../hooks/useQuery'
import { useTaskManagement, useProfile } from '../../../../hooks'
import { getDueDateString } from '../task-form'

export const ModalAction = ({ t, selectedTasks, isModalVisible, setIsModalVisible, setPage }) => {
  const query = useQuery()
  const taskCategoryId = query.get('taskCategoryId')
  const taskTypeId = query.get('taskTypeId')
  const { profile: { userId } } = useProfile()
  const form = useForm()
  const { handleSubmit, reset } = form

  const [selectedStatus, setSelectedStatus] = useState(null)
  const { deleteSelectedTasksAction, loadTasksAction, updateSelectedTasksAction } = useTaskManagement()

  const handleSelectStatus = (e) => {
    const { value } = e.target
    if (value === selectedStatus) {
      setSelectedStatus(null)
    } else {
      setSelectedStatus(value)
    }
  }

  const initializeForm = () => {
    reset({
      dueDate: null,
      dueTime: null
    })
    setSelectedStatus(null)
  }

  const handleCancel = () => {
    setIsModalVisible(false)
    initializeForm()
  }

  const handleOk = (formData) => {
    const taskIds = selectedTasks.map(({ id }) => id)
    const status = selectedStatus ? STATUS_VALUE[selectedStatus] : null
    const dueDate = formData.dueDate && formData.dueTime ? getDueDateString(formData.dueDate, formData.dueTime) : null
    const callback = () => {
      loadTasksAction({
        taskTypeId: taskTypeId || TASK_CATEGORY_VALUE.MY_TASK,
        referenceId: taskCategoryId || userId
      })
      setPage(DEFAULT_PAGE.PAGE)
      setIsModalVisible(false)
      initializeForm()
    }
    updateSelectedTasksAction({ taskIds, status, dueDate, callback })
  }

  const handleDeleteSelectedTasks = () => {
    const taskIds = selectedTasks.map(({ id }) => id)
    const callback = () => {
      loadTasksAction({
        taskTypeId: taskTypeId || TASK_CATEGORY_VALUE.MY_TASK,
        referenceId: taskCategoryId || userId
      })
      setPage(DEFAULT_PAGE.PAGE)
      setIsModalVisible(false)
      initializeForm()
    }
    deleteSelectedTasksAction({ taskIds, callback })
  }

  const Footer = () => (
    <div className="footer">
      <PrimaryButton
        onClick={handleSubmit(handleOk)}
        title={t('task.save')}
      />
      <OutlineButton onClick={handleCancel} title={t('task.cancel')} />
      <Popconfirm
        onConfirm={handleDeleteSelectedTasks}
        cancelText={t('common.cancel')}
        title={t('task.delete_confirm')}
      >
        <OutlineDeleteButton title={t('task.delete')} color="error" />
      </Popconfirm>
    </div>
  )

  return (
    <ModalWrapper
      centered
      open={isModalVisible}
      onCancel={handleCancel}
      title={t('task.bulk_change')}
      footer={<Footer />}
    >
      <FormProvider {...form}>
        <form>
          <Status t={t} selectedStatus={selectedStatus} handleSelectStatus={handleSelectStatus} />
          <DueDateTime
            t={t}
            dateProps={{
              defaultValue: null,
              allowClear: true,
              placeholder: t('task.select')
            }}
            timeDefaultValue={null}
            timeProps={{
              allowClear: true,
              placeholder: t('task.select'),
              style: { width: 80 }
            }}
          />
        </form>
      </FormProvider>
    </ModalWrapper>
  )
}

ModalAction.propTypes = {
  t: PropTypes.func,
  selectedTasks: PropTypes.array,
  isModalVisible: PropTypes.bool,
  setIsModalVisible: PropTypes.func,
  setPage: PropTypes.func
}
